import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { CategoryInterface } from './type';
import { CategoryRepository } from './repository';
import type { ProductInterface } from '../products/type';
import { useUsers } from '@/features/users/controller'

export const useCategories = defineStore('categories', () => {

    const $userStore = useUsers()

    const categoryRepository = new CategoryRepository();
    const categories = ref<CategoryInterface[]>([])
    const activeCategory = ref<CategoryInterface | null>(null)
    const categoryProducts = ref<ProductInterface[]>([]);
    
    // Pagination state
    const productPagination = ref({
        currentPage: 1,
        lastPage: 1,
        perPage: 4,
        total: 0,
        from: 0,
        to: 0
    });
    
    // Pagination state
    const categoriesPagination = ref({
        currentPage: 1,
        lastPage: 1,
        perPage: 4,
        total: 0,
        from: 0,
        to: 0
    });

    const getCategories = async (page: number = 1, perPage: number = 12, parentId: number | null = null) => {
        let userId = null
        if ($userStore.selectedUserForShop && $userStore.loggedUser && ($userStore.loggedUser.type === 'administrator' || $userStore.loggedUser.type === 'storekeeper') && typeof $userStore.selectedUserForShop === 'object') {
            userId = $userStore.selectedUserForShop.id
        } else if ($userStore.loggedUser) {
            userId = $userStore.loggedUser.id
        }
        const res = await categoryRepository.getCategories({ page, perPage, parentId, userId });
        if (!res.error) {
            categories.value = res.data.data;
            categoriesPagination.value = {
                currentPage: res.data.current_page,
                lastPage: res.data.last_page,
                perPage: res.data.per_page,
                total: res.data.total,
                from: res.data.from,
                to: res.data.to
            };
        }
        return res;
    }

    const getCategory = async (id: number, page: number = 1, perPage: number = 12, parentId: number | null = null) => {
        let userId = null
        if ($userStore.selectedUserForShop && $userStore.loggedUser && ($userStore.loggedUser.type === 'administrator' || $userStore.loggedUser.type === 'storekeeper') && typeof $userStore.selectedUserForShop === 'object') {
            userId = $userStore.selectedUserForShop.id
        } else if ($userStore.loggedUser) {
            userId = $userStore.loggedUser.id
        }
        const res = await categoryRepository.getCategory(id, { page, perPage, parentId, userId });
        if (!res.error) {
            activeCategory.value = res.data.category;
            categoryProducts.value = res.data.products.data;
            productPagination.value = {
                currentPage: res.data.products.current_page,
                lastPage: res.data.products.last_page,
                perPage: res.data.products.per_page,
                total: res.data.products.total,
                from: res.data.products.from,
                to: res.data.products.to
            };
        }
        return res;
    }

    return {
        categories,
        activeCategory,
        categoriesPagination,
        productPagination,
        categoryProducts,
        getCategory,
        getCategories,
    }

}, {
    persist: {
        paths: [],
    },
})